import React, { useEffect } from 'react';
import { useLocation } from '@reach/router';
import '../styles/global.css';
import Header from './header';
import Footer from './footer';
import BackToTop from './BackToTop';
import { useSiteMetadata } from '../hooks/use-site-metadata';
import { Helmet } from 'react-helmet';

export default function Layout({ children }) {
  const location = useLocation();
  const { siteUrl } = useSiteMetadata();

  const pathPrefix = typeof __PATH_PREFIX__ !== 'undefined' ? __PATH_PREFIX__ : '';
  const rawPathname = location.pathname || '/';
  const normalizedPathname =
    pathPrefix && rawPathname.startsWith(pathPrefix)
      ? rawPathname.slice(pathPrefix.length) || '/'
      : rawPathname;

  useEffect(() => {
    const currentDomain = window.location.origin;

    if (currentDomain === siteUrl) {
      document.documentElement.lang = 'en';
    }
  }, [siteUrl]);

  useEffect(() => {
    document.body.classList.add('!mt-0');

    const pathname = normalizedPathname.replace(/\//g, '-').replace(/^-|-$/g, '');
    document.body.id = pathname ? pathname : 'home';

    const observerCallback = (mutationsList) => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach(node => {
            if (node.nodeType === 1) {
              const elements = node.querySelectorAll('[data-radix-menubar-content]');
              elements.forEach(element => {
                if (element.parentElement) {
                  element.parentElement.classList.add('has-radix-menubar-content');
                }
              });
            }
          });
        }
      }
    };

    const observer = new MutationObserver(observerCallback);

    observer.observe(document.body, { childList: true, subtree: true });

    return () => {
      observer.disconnect();
      document.body.classList.remove('!mt-0');
      document.body.removeAttribute('id');
    };
  }, [normalizedPathname]);

  const customPages = ["/", "/past-conferences/", "/conference-themes-and-topics/", "/explore-sydney/", "/presentation-submission/", "/workshops/"];
  const shouldHaveClasses = customPages.includes(normalizedPathname);

  const analyticsScript = `
    var _paq = window._paq = window._paq || [];
    /* tracker methods like "setCustomDimension" should be called before "trackPageView" */
    _paq.push(['trackPageView']);
    _paq.push(['enableLinkTracking']);
    (function() {
      var u="//analytics.icmsaust.com.au/";
      _paq.push(['setTrackerUrl', u+'matomo.php']);
      _paq.push(['setSiteId', '4']);
      var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];
      g.async=true; g.src=u+'matomo.js'; s.parentNode.insertBefore(g,s);
    })();
  `;

  if (normalizedPathname === "/program/") {
    return (
      <>
        <Helmet>
          <script type="text/javascript">{analyticsScript}</script>
        </Helmet>
        <main className="p-4 overflow-hidden">
          {children}
        </main>
        <BackToTop />
      </>
    );
  }

  return (
    <>
      <Helmet>
        <script type="text/javascript">{analyticsScript}</script>
      </Helmet>
      <Header />
      <main className={`${shouldHaveClasses ? '' : 'flex flex-col gap-12 py-12 md:py-16'}`}>
        {children}
      </main>
      <BackToTop />
      <Footer />
    </>
  );
}
